import { Button, ButtonProps, styled } from '@mui/material';
import { colors } from 'theme/mui/colors';

type Props = ButtonProps & {
  label: string;
};

const LinkButton = (props: Props) => {
  const { label, ...rest } = props;
  return <UnderlinedButton {...rest}>{label}</UnderlinedButton>;
};

const UnderlinedButton = styled(Button)(() => ({
  textDecoration: 'underline',
  textTransform: 'none',
  minWidth: 'fit-content',
  color: colors.base.level70,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiCircularProgress-root': {
    color: colors.red[500],
  },
}));

export default LinkButton;
